import { render, staticRenderFns } from "./SectionFreeButtons.vue?vue&type=template&id=9a9fa08a&"
import script from "./SectionFreeButtons.vue?vue&type=script&lang=js&"
export * from "./SectionFreeButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports